import { render, staticRenderFns } from "./json-ld.vue?vue&type=template&id=65c086e1"
import script from "./json-ld.vue?vue&type=script&lang=ts"
export * from "./json-ld.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports